"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const index_1 = require("../index");
const context_1 = require("../../context");
exports.SearchResultBody = React.memo(() => {
    const { isHitsAndFiltersLoading } = (0, context_1.useSearchResultContext)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container-px mb-5xl sm:mb-9xl", children: [isHitsAndFiltersLoading ? (0, jsx_runtime_1.jsx)(index_1.ContentLoading, {}) : (0, jsx_runtime_1.jsx)(index_1.SearchResultContent, {}), (0, jsx_runtime_1.jsx)(index_1.ErrorMessage, {}), (0, jsx_runtime_1.jsx)(index_1.ZeroResult, {})] }));
});
